import Vue from 'vue'
import csvtojson from 'csvtojson'
Vue.prototype.$csvtojson=csvtojson